import { Component, OnInit,Input } from '@angular/core';
import { Router } from '@angular/router';
/**
  Componente que muestra un banner con información sobre irregularidades operativas (IROPS).
  Este componente permite mostrar un mensaje principal y un botón para cambiar de vuelo,
  redirigiendo al usuario a una nueva página para seleccionar un vuelo alternativo.
**/
@Component({
    selector: 'app-banner-irops-view',
    templateUrl: './banner-irops-view.component.html',
    styleUrls: ['./banner-irops-view.component.scss'],
    standalone: false
})
export class BannerIropsViewComponent implements OnInit {
    /**
    Texto principal que se muestra en el banner.
    @type {string}
  **/
    @Input() copyTextMain = '';

    /**
      Indica si se debe mostrar el botón para cambiar de vuelo.
      @type {boolean}
      @default true
    **/
    @Input() showButtonChangeFlight = true;
  
    /**
      Texto que se muestra en el botón para cambiar de vuelo.
      @type {string}
    **/
    @Input() copyButtonBanner = '';

  constructor(
    private _router: Router
  ) {}

  ngOnInit(): void {
  }

  onChangeFlight() {
    this._router.navigate(['/srIrops/newFlight']);
  }

}
